import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "inline-display-icon",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.75 3C2.23122 3 1 4.23122 1 5.75V17.75C1 19.2688 2.23122 20.5 3.75 20.5H11.7466L11.75 20.5L11.7534 20.5H19.75C21.2688 20.5 22.5 19.2688 22.5 17.75V5.75C22.5 4.23122 21.2688 3 19.75 3H3.75ZM12.5 19H19.75C20.4404 19 21 18.4404 21 17.75V5.75C21 5.05964 20.4404 4.5 19.75 4.5H3.75C3.05964 4.5 2.5 5.05964 2.5 5.75V17.75C2.5 18.4404 3.05964 19 3.75 19H11V12.5597L7.27933 16.2803C6.98644 16.5732 6.51156 16.5732 6.21867 16.2803C5.92578 15.9874 5.92578 15.5126 6.21867 15.2197L11.2197 10.2187C11.5126 9.92578 11.9874 9.92578 12.2803 10.2187L17.2813 15.2197C17.5742 15.5126 17.5742 15.9874 17.2813 16.2803C16.9884 16.5732 16.5136 16.5732 16.2207 16.2803L12.5 12.5596V19Z"
    }, null, -1)
  ])))
}
export default { render: render }